module.exports = __webpack_public_path__ + "res/volante_icon.png";